$(function () {
    var displayFiltersInput = document.getElementById('display-filters-input');
    var filterContainer = document.getElementById('filter-container');

    $('.show-filters').hide();

    $('#toggle-filters').on('click', function () {
        if (filterContainer.classList.contains('hidden')) {
            displayFiltersInput.value = true;
            filterContainer.classList.remove('hidden');
        }
        else {
            displayFiltersInput.value = false;
            filterContainer.classList.add('hidden');
        }

        $(this).find('.show-hide').each(function () {
            $(this).toggle();
        });
            
    });
});
